jQuery(function($)
{
    /**
	 * @type {jQuery}
	 */
    var $addressDeleteOverlayTrigger = $('.js-address-entry .overlay-trigger');

    /**
	 * @type {jQuery}
	 */
    var $addressDeleteOverlay = $('#overlay-delete-address');

    /**
	 * @type {jQuery}
	 */
    var $deleteForm = $('form', $addressDeleteOverlay);

    /**
	 * @type {string}
	 */
    var urlPath = $deleteForm.attr('action');

    /**
	 * Fetch address id from address entry data-address-id attribute
	 * @param  {jQuery}
	 * @return {string}
	 */
    function fetchAddressId($addressEntry)
    {
        return $addressEntry.data('address-id');
    }

    /**
	 * Assign form action to delete form in overlay
	 * @param  {string} action
	 */
    function assignFormAction(action)
    {
        $deleteForm.attr('action', action);
    }

    /**
	 * Fetches the address id, composes an url with the address id as parameter
	 * and assigns it as action to the delete form
	 */
    function handleClickDeleteAddressEntry()
    {
        var $this = $(this);
        var $addressEntry = $this.parents('.js-address-entry').eq(0);

        var addressId = fetchAddressId($addressEntry);
        var urlParam = { id: addressId };

        var urlObject = new URI(urlPath);

        urlObject.addSearch(urlParam);

        assignFormAction(urlObject.href());
    }

    $addressDeleteOverlayTrigger.on('click', handleClickDeleteAddressEntry);
});
